'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * This renders the age requirements table from page 21
 * of the Reboot Kids handbook
 */
var PercentRequirementsMetTable = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(PercentRequirementsMetTable, _Component);

  function PercentRequirementsMetTable() {
    (0, _classCallCheck3.default)(this, PercentRequirementsMetTable);
    return (0, _possibleConstructorReturn3.default)(this, (PercentRequirementsMetTable.__proto__ || (0, _getPrototypeOf2.default)(PercentRequirementsMetTable)).apply(this, arguments));
  }

  (0, _createClass3.default)(PercentRequirementsMetTable, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          ReactBootstrap.Row,
          null,
          _react2.default.createElement(
            ReactBootstrap.Col,
            { md: 6 },
            _react2.default.createElement(ReactBootstrap.Image, { src: this.props.yearImage, responsive: true })
          ),
          _react2.default.createElement(
            ReactBootstrap.Col,
            { md: 6 },
            _react2.default.createElement(
              'h4',
              null,
              this.props.ageBracket
            ),
            _react2.default.createElement(
              ReactBootstrap.Table,
              { striped: true, bordered: true, responsive: true },
              _react2.default.createElement(
                'thead',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'th',
                    null,
                    _react2.default.createElement(
                      'strong',
                      null,
                      'Core food group'
                    )
                  ),
                  _react2.default.createElement(
                    'th',
                    null,
                    '% requirements met'
                  )
                )
              ),
              _react2.default.createElement(
                'tbody',
                null,
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    'Vegetables'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    this.props.vegetablePercent
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    'Meat and alternatives'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    this.props.meatPercent
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    'Grain and cereals'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    this.props.grainPercent
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    'Dairy and alternatives'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    this.props.dairyPercent
                  )
                ),
                _react2.default.createElement(
                  'tr',
                  null,
                  _react2.default.createElement(
                    'td',
                    null,
                    'Fruit'
                  ),
                  _react2.default.createElement(
                    'td',
                    null,
                    this.props.fruitPercent
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return PercentRequirementsMetTable;
}(_react.Component), _class.propTypes = {
  ageBracket: _propTypes2.default.string,
  yearImage: _propTypes2.default.string,
  vegetablePercent: _propTypes2.default.string,
  meatPercent: _propTypes2.default.string,
  grainPercent: _propTypes2.default.string,
  dairyPercent: _propTypes2.default.string,
  fruitPercent: _propTypes2.default.string
}, _temp);
exports.default = PercentRequirementsMetTable;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Resources/PercentRequirementsMetTable.js
// module id = 1258
// module chunks = 0